import { useSelector } from "react-redux";
import {
    getDCUIFooterBGColor,
    getDCUIFooterText,
    getDCUIFooterTextColor,
    getFooterTheme
} from "@redux/selectors/verification-configuration-selectors";
import { CSSProperties } from "react";
import styles from "./footer-container.less";
import { getLanguageContent } from "@redux/selectors/language-selectors";

export const FooterContainer = () => {
    const content = useSelector(getLanguageContent);
    const footerTheme = useSelector(getFooterTheme);
    const dcuiFooterBGColor = useSelector(getDCUIFooterBGColor);
    const dcuiFooterText = useSelector(getDCUIFooterText);
    const dcuiFooterTextColor = useSelector(getDCUIFooterTextColor);

    const footerText = content.footer.text || dcuiFooterText;
    const footerTextColor = footerTheme.textColor || dcuiFooterTextColor;
    const footerBGColor = footerTheme.backgroundColor || dcuiFooterBGColor;

    const footerStyles: CSSProperties = {
        color: footerTextColor,
        backgroundColor: footerBGColor
    };

    return (
        <div id="footer-container" className={styles.footerContainer} style={footerStyles}>
            <footer id="footer-content" className={styles.footerContent}>
                {(footerText && footerText !== ".")
                    ? <h3>{footerText}</h3>
                    : null
                }
            </footer>
        </div>
    );
};
